// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const resetReportIsScrollable = () => ({
    type: actions.RESET_PIP_HISTORY_REPORT_IS_SCROLLABLE
});

export const toggleReportIsScrollable = () => ({
    type: actions.TOGGLE_PIP_HISTORY_REPORT_IS_SCROLLABLE
});



// WEBPACK FOOTER //
// ./src/reports/pip-history/action-creators/report-is-scrollable.js